import React, { Component } from 'react';
import { Button, TextField } from '@mui/material';
import { post } from '../../util/api';
import { connect } from 'react-redux';
import { updateProfile } from '../../actions/access.actions';
import { CopyToClipboard } from 'react-copy-to-clipboard';

class UserPage extends Component {
	state = {
		link: 'generate',
	};

	handleChange = (e) => this.setState({ [e.target.name]: e.target.value });
	handleSubmit = async () => {
		await post('/maytapi/custompaddlelink', {
			admin: true,
			custom_price: this.state.price,
			title: this.state.title,
			message: this.state.message,
			plan_id: 607031,
		}).then((data) => {
			this.setState({ link: data.data.response.url });
		});
	};
	render() {
		return (
			<div style={{ padding: '0 15px 0 15px' }}>
				<form onSubmit={this.handleSubmit}>
					<TextField
						sx={{ marginBottom: '10px' }}
						fullWidth
						id="price"
						label="Price"
						name="price"
						icon="dollar"
						iconPosition="left"
						placeholder="Enter price"
						type="text"
						required
						value={this.state.price}
						onChange={this.handleChange}
					/>
					<TextField
						sx={{ marginBottom: '10px' }}
						fullWidth
						id="title"
						label="Title"
						icon="address card"
						required
						name="title"
						placeholder="Enter plan name"
						iconPosition="left"
						type="text"
						value={this.state.title}
						onChange={this.handleChange}
					/>
					<TextField
						sx={{ marginBottom: '10px' }}
						fullWidth
						id="message"
						label="Message"
						icon="address card"
						name="message"
						placeholder="Enter message"
						iconPosition="left"
						type="text"
						value={this.state.message}
						onChange={this.handleChange}
					/>
					<Button fullWidth fluid type="submit" sx={{ background: '#02b002', color: 'white', ':hover': { background: '#018c01' } }} positive>
						Generate
					</Button>
				</form>
				<div style={{ marginTop: '10px', display: 'grid' }}>
					<CopyToClipboard text={this.state.link}>
						<Button
							type="copy"
							style={{ marginLeft: 'auto', marginBottom: '10px' }}
							sx={{ background: '#eeeeee', ':hover': { background: '#d5d5d5' } }}
						>
							Copy
						</Button>
					</CopyToClipboard>
					<p style={{ wordBreak: 'break-all' }}>{this.state.link}</p>
				</div>
			</div>
		);
	}
}

export default connect(
	(state) => ({ user: state.access.user.loggedUserObj }),
	(dispatch) => ({ updateUser: (user) => dispatch(updateProfile(user)) })
)(UserPage);
